module.exports = __webpack_public_path__ + "static/media/jurassic.e9c1b96e.jpeg";